var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNbPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 31,
    height: 31,
    rx: 15,
    fill: "#56CD62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8798 8.28294H20.1203M11.8798 12.2924H20.1203M17.7168 22.7171L11.8798 16.3019H13.9399C18.5182 16.3019 18.5182 8.28294 13.9399 8.28294",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbPricing);
export default __webpack_public_path__ + "static/media/nb_pricing.a6b9ac35b5b052fb3664d0be7e0d864a.svg";
export { ForwardRef as ReactComponent };